import {IS_DEV} from '../config'

export const ErrCodes = {
  'auth/email_required': 'Preencha seu e-mail corretamente e tente novamente',
  'auth/password_required': 'Preencha sua senha de acesso e tente novamente',
  'auth/invalid_credentials': 'O e-mail e/ou senha inseridos são inválidos. Verifique e tente novamente',

  'user/email-being-used': 'O e-mail selecionado já está sendo utilizado',
};

export const getErrorMessage = err => {
  if (ErrCodes[err]) return ErrCodes[err];

  if (err && ErrCodes[err.message]) return ErrCodes[err.message];
  if (err && ErrCodes[err.code]) return ErrCodes[err.code];

  if (err && err.data) return getErrorMessage(err.data);

  if (IS_DEV) console.log('[Error] unhandled error ', err);
  return 'Algum erro aconteceu. Tente novamente em alguns instantes';
};



// WEBPACK FOOTER //
// ./src/helpers/errors.js